export interface CancelCaseModalInfoProps {
	patientName?: string;
	surgeonName: string;
	surgeryDate: string | Date;
	duration?: string;
	hospitalName?: string;
	unit?: string;
}

export interface CancelCaseFormData {
	ssmCancellationReason: string;
	intendToReschedule: boolean | null;
	message: string;
}

export const cancelCaseFormDefaultValues: CancelCaseFormData = {
	ssmCancellationReason: '',
	intendToReschedule: null,
	message: '',
};

export interface CancelCaseModalProps {
	caseInfo: CancelCaseModalInfoProps;
	onCaseCancel: (data: CancelCaseFormData) => void;
	cancellationReasons?: string[];
}
